import React from 'react';

const Title = () => (
        <div className="info">
            <h1>Weather Finder</h1>
            <p>find out temperature , condition and more ...</p>
        </div>
)

export default Title;